<template>
  <div><i class="fa-sharp fa-regular fa-exclamation-triangle"></i> Failed to load module.</div>
</template>

<script>
export default {}
</script>
